/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SymbolTypeEnum,
    SymbolTypeEnumFromJSON,
    SymbolTypeEnumFromJSONTyped,
    SymbolTypeEnumToJSON,
} from './SymbolTypeEnum';

/**
 * 
 * @export
 * @interface UnrealizedAllocationDto
 */
export interface UnrealizedAllocationDto {
    /**
     * 
     * @type {SymbolTypeEnum}
     * @memberof UnrealizedAllocationDto
     */
    type: SymbolTypeEnum | null;
    /**
     * Aktuální jednotková tržní cena
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    currentUnitPrice: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    realizedInvestmentValue: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    dividendsValue: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    taxFreeAmount: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    taxFreeValue: number;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    referenceSymbolId?: string;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    referenceSymbolCurrency?: string;
    /**
     * 
     * @type {Date}
     * @memberof UnrealizedAllocationDto
     */
    dateTo: Date;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    symbol: string;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    symbolId: string;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    symbolName: string;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    symbolCurrency: string;
    /**
     * 
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    exchangeId: string;
    /**
     * Investovaná částka
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    invested: number;
    /**
     * Průměrná investovaná částka
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    averageInvested: number;
    /**
     * Aktuální hodnota
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    value: number;
    /**
     * Průměrná aktuální hodnota
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    averageValue: number;
    /**
     * Měna
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    currency: string;
    /**
     * Držené množství
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    amount: number;
    /**
     * Držený poměr
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    weight: number;
    /**
     * Barva
     * @type {string}
     * @memberof UnrealizedAllocationDto
     */
    color: string;
    /**
     * Procentuální zisk
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    profitPercentage: number;
    /**
     * Zisk
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    profitValue: number;
    /**
     * Procentuální zisk (realizovaný + nerealizovaný)
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    totalProfitPercentage: number;
    /**
     * Zisk (realizovaný + nerealizovaný)
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    totalProfitValue: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    currencyImpactValue: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    currencyImpactPercentage: number;
    /**
     * 
     * @type {number}
     * @memberof UnrealizedAllocationDto
     */
    feesValue: number;
}

export function UnrealizedAllocationDtoFromJSON(json: any): UnrealizedAllocationDto {
    return UnrealizedAllocationDtoFromJSONTyped(json, false);
}

export function UnrealizedAllocationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnrealizedAllocationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': SymbolTypeEnumFromJSON(json['type']),
        'currentUnitPrice': json['currentUnitPrice'],
        'realizedInvestmentValue': json['realizedInvestmentValue'],
        'dividendsValue': json['dividendsValue'],
        'taxFreeAmount': json['taxFreeAmount'],
        'taxFreeValue': json['taxFreeValue'],
        'referenceSymbolId': !exists(json, 'referenceSymbolId') ? undefined : json['referenceSymbolId'],
        'referenceSymbolCurrency': !exists(json, 'referenceSymbolCurrency') ? undefined : json['referenceSymbolCurrency'],
        'dateTo': (new Date(json['dateTo'])),
        'symbol': json['symbol'],
        'symbolId': json['symbolId'],
        'symbolName': json['symbolName'],
        'symbolCurrency': json['symbolCurrency'],
        'exchangeId': json['exchangeId'],
        'invested': json['invested'],
        'averageInvested': json['averageInvested'],
        'value': json['value'],
        'averageValue': json['averageValue'],
        'currency': json['currency'],
        'amount': json['amount'],
        'weight': json['weight'],
        'color': json['color'],
        'profitPercentage': json['profitPercentage'],
        'profitValue': json['profitValue'],
        'totalProfitPercentage': json['totalProfitPercentage'],
        'totalProfitValue': json['totalProfitValue'],
        'currencyImpactValue': json['currencyImpactValue'],
        'currencyImpactPercentage': json['currencyImpactPercentage'],
        'feesValue': json['feesValue'],
    };
}

export function UnrealizedAllocationDtoToJSON(value?: UnrealizedAllocationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': SymbolTypeEnumToJSON(value.type),
        'currentUnitPrice': value.currentUnitPrice,
        'realizedInvestmentValue': value.realizedInvestmentValue,
        'dividendsValue': value.dividendsValue,
        'taxFreeAmount': value.taxFreeAmount,
        'taxFreeValue': value.taxFreeValue,
        'referenceSymbolId': value.referenceSymbolId,
        'referenceSymbolCurrency': value.referenceSymbolCurrency,
        'dateTo': (value.dateTo.toISOString()),
        'symbol': value.symbol,
        'symbolId': value.symbolId,
        'symbolName': value.symbolName,
        'symbolCurrency': value.symbolCurrency,
        'exchangeId': value.exchangeId,
        'invested': value.invested,
        'averageInvested': value.averageInvested,
        'value': value.value,
        'averageValue': value.averageValue,
        'currency': value.currency,
        'amount': value.amount,
        'weight': value.weight,
        'color': value.color,
        'profitPercentage': value.profitPercentage,
        'profitValue': value.profitValue,
        'totalProfitPercentage': value.totalProfitPercentage,
        'totalProfitValue': value.totalProfitValue,
        'currencyImpactValue': value.currencyImpactValue,
        'currencyImpactPercentage': value.currencyImpactPercentage,
        'feesValue': value.feesValue,
    };
}

